import {
  CellContentCheckSimpleAll,
  CommonRenderHeaderCellProps,
  CommonTableTemplate,
} from 'app/common/templates-next/table-template'

import { Th } from 'app/common/ui-components/table'

import { DishesTableColumn } from './dishesTableProps'

export const dishesTableRenderHeaderCell = (
  params: CommonRenderHeaderCellProps<Record<string, unknown>, string>,
) => {
  const { columnKey, headerCellProps } = params

  if (columnKey === DishesTableColumn.Check) {
    return (
      <Th {...headerCellProps} bgFilled>
        <CellContentCheckSimpleAll />
      </Th>
    )
  }
  return CommonTableTemplate.defaultRenderHeaderCell({
    ...params,
    headerCellProps: { ...headerCellProps, bgFilled: true },
  })
}
export const dishesTableRenderHeaderCellClear = (
  params: CommonRenderHeaderCellProps<Record<string, unknown>, string>,
) => {
  const { headerCellProps } = params

  return CommonTableTemplate.defaultRenderHeaderCell({
    ...params,
    headerCellProps: { ...headerCellProps, bgFilled: true },
  })
}
